<template>
    <div class="search-input">
        <i class="fas fa-search"></i>
        <input type="text" placeholder="find your wine" class="product-search" @keyup="search">
    </div>
</template>

<script>
    export default {
        name: "ProductSearch",
        methods: {
            search: function(e) {
                this.$root.$emit('productSearch', e.target.value);
            }
        }
    }
</script>
